import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          fill="currentcolor"
          d="M15.3 2C15.8 2 16.214 2.16 16.574 2.47L16.707 2.593L21.407 7.293C21.755 7.641 21.953 8.038 21.993 8.517L22 8.7V15.3C22 15.8 21.84 16.214 21.53 16.574L21.407 16.707L16.707 21.407C16.359 21.755 15.962 21.953 15.483 21.993L15.3 22H8.7C8.2 22 7.786 21.84 7.426 21.53L7.293 21.407L2.593 16.707C2.245 16.359 2.047 15.962 2.007 15.483L2 15.3V8.7C2 8.2 2.16 7.786 2.47 7.426L2.593 7.293L7.293 2.593C7.641 2.245 8.038 2.047 8.517 2.007L8.7 2H15.3ZM12.01 15L11.883 15.007C11.64 15.0359 11.4159 15.153 11.2534 15.336C11.0909 15.519 11.0011 15.7552 11.0011 16C11.0011 16.2448 11.0909 16.481 11.2534 16.664C11.4159 16.847 11.64 16.9641 11.883 16.993L12 17L12.127 16.993C12.37 16.9641 12.5941 16.847 12.7566 16.664C12.9191 16.481 13.0089 16.2448 13.0089 16C13.0089 15.7552 12.9191 15.519 12.7566 15.336C12.5941 15.153 12.37 15.0359 12.127 15.007L12.01 15ZM12 7C11.7551 7.00003 11.5187 7.08996 11.3356 7.25272C11.1526 7.41547 11.0357 7.63975 11.007 7.883L11 8V12L11.007 12.117C11.0359 12.36 11.153 12.5841 11.336 12.7466C11.519 12.9091 11.7552 12.9989 12 12.9989C12.2448 12.9989 12.481 12.9091 12.664 12.7466C12.847 12.5841 12.9641 12.36 12.993 12.117L13 12V8L12.993 7.883C12.9643 7.63975 12.8474 7.41547 12.6644 7.25272C12.4813 7.08996 12.2449 7.00003 12 7Z"
        />
      </g>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-alert-filled" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
